module.exports = __webpack_public_path__ + "img/soft-grove-bathroom-3.e50c3bae.jpeg";